export default "__VITE_ASSET__BMW1zg2x__"